// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Q9h0","questions":"styles_questions__DfK3e","footer":"styles_footer__3ScSs"};